<template>
  <template v-if="active === 0">
    <el-form style="margin: 0 30px" ref="buyForm" :model="buyForm" label-position="top">
      <el-form-item label="模板名称">
        <el-link :href="previewUrl" target="_blank" style="margin-top: -3px">{{ name }}</el-link>
      </el-form-item>
      <el-form-item label="费用合计">
        <span style="font-size: 18px; color: #fa5300">￥{{ getPayAmount().toFixed(2) }}</span>
        <span>{{ getThemeDiscount() }}</span>
      </el-form-item>
      <el-divider></el-divider>

      <div class="el-dialog__footer" style="text-align: center">
        <el-button type="primary" @click.prevent="btnNextClick">下一步</el-button>
      </div>
    </el-form>
  </template>
  <template v-else-if="active === 1">
    <template v-if="payForm.isPurchased">
      <div style="text-align: center">
        <h3 style="text-align: center; color: #67c23a">模板购买成功！</h3>
        <el-button type="primary" v-on:click="btnPayCloseClick">关 闭</el-button>
      </div>
    </template>
    <template v-else-if="payForm.isQrCode">
      <div style="text-align: center">
        <h3>打开手机{{ getChannel() }}，扫一扫下面的二维码，即可完成支付</h3>
        <div style="margin: 10px auto">
          <img v-if="payForm.channel == 'AliPay'" src="/home/img/channel_alipay.gif" />
          <img v-else src="/home/img/channel_weixin.gif" />
        </div>
        <canvas id="qrcode" style="margin: 0px auto; width: 260px; height: 260px"></canvas>
      </div>
    </template>
    <template v-else>
      <div style="margin-bottom: 10px; border: 1px solid #ebebeb; border-radius: 3px">
        <div style="padding: 24px">
          <h3 style="text-align: center; margin-bottom: 40px" v-html="getPayDescription()"></h3>

          <el-divider></el-divider>

          <div style="text-align: center">
            <div
              style="
                width: 49%;
                text-align: center;
                border-right: 1px solid #eff2f6;
                display: inline-block;
                width: 49%;
                box-sizing: border-box;
                vertical-align: top;
              "
            >
              <span style="display: block; color: #8492a6; font-size: 14px; margin: 20px 0">
                <img src="/home/img/channel_alipay.gif" />
              </span>
              <div class="el-image">
                <el-button type="primary" v-on:click="btnPayChannelClick('AliPay')">使用支付宝支付</el-button>
              </div>
            </div>
            <div
              style="
                width: 49%;
                text-align: center;
                display: inline-block;
                width: 49%;
                box-sizing: border-box;
                vertical-align: top;
              "
            >
              <span style="display: block; color: #8492a6; font-size: 14px; margin: 20px 0">
                <img src="/home/img/channel_weixin.gif" />
              </span>
              <div class="el-image">
                <el-button type="primary" v-on:click="btnPayChannelClick('WxPay')">使用微信支付</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <p style="height: 30px"></p>
  </template>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import api from '@/api/my/templates';
import utils from '@/utils';
import QRCode from 'qrcode';

interface IBuyForm {
  userName: string;
  name: string;
}

interface IPayForm {
  channel: string;
  isPurchased: boolean;
  isQrCode: boolean;
  orderNo: string;
  failureCount: 0;
}

interface IState {
  active: number;
  previewUrl: string;
  price: number;
  discount: number;
  buyForm: IBuyForm;
  payForm: IPayForm;
}

export default defineComponent({
  name: 'Domains',
  emits: ['close'],
  props: {
    userName: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      active: 0,
      previewUrl: '',
      price: 0,
      discount: 0,
      buyForm: {} as IBuyForm,
      payForm: {} as IPayForm,
    } as IState;
  },
  methods: {
    apiGet() {
      this.active = 0;
      this.previewUrl = '';
      this.price = 0;
      this.discount = 0;
      this.buyForm = {} as IBuyForm;
      this.payForm = {} as IPayForm;

      api.buy(
        {
          userName: this.userName,
          name: this.name,
        },
        (res) => {
          if (!res) return;
          this.previewUrl = res.previewUrl;
          this.price = res.price;
          this.discount = res.discount;
        },
      );
    },

    getThemeDiscount(): string {
      return this.discount < 1 ? `（${this.discount * 10}折）` : '';
    },

    getPayAmount(): number {
      return this.price * this.discount;
    },

    getChannel() {
      return this.payForm.channel === 'AliPay' ? '支付宝' : '微信';
    },

    getPayDescription() {
      const amount = this.getPayAmount().toFixed(2);
      return `
        模板名称:
        <span style="color: #fa5300; margin-right: 15px">${this.name}</span>
        费用合计:
        <span style="color: #fa5300">￥${amount}</span>`;
    },

    payQuery() {
      const interval = setInterval(() => {
        api.query(
          {
            orderNo: this.payForm.orderNo,
          },
          (res) => {
            this.payForm.isPurchased = res.isPurchased;

            if (this.payForm.isPurchased) {
              clearInterval(interval);
            }
          },
        );
      }, 3000);
    },

    btnPayChannelClick(channel: string) {
      this.payForm.channel = channel;

      api.pay(
        {
          userName: this.userName,
          name: this.name,
          channel: this.payForm.channel,
          amount: this.getPayAmount(),
        },
        (res) => {
          if (!res) return;

          this.payForm.isQrCode = true;
          this.payForm.orderNo = res.orderNo;

          setTimeout(() => {
            QRCode.toCanvas(document.getElementById('qrcode'), res.qrCodeUrl, { width: 260 });
          }, 100);

          this.payQuery();
        },
        (error) => {
          console.log(error);
          this.payForm.failureCount += 1;
          if (this.payForm.failureCount < 3) {
            this.btnPayChannelClick(channel);
          } else {
            utils.loading(false);
            utils.error(error);
          }
        },
      );
    },

    btnNextClick() {
      this.active += 1;
      this.payForm.failureCount = 0;
    },

    btnPayCloseClick() {
      this.$emit('close');
    },
  },
  watch: {
    userName: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.apiGet();
        }
      },
      deep: false,
    },
    name: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.apiGet();
        }
      },
      deep: false,
    },
  },
  mounted() {
    this.apiGet();
  },
});
</script>
